<template>
  <!-- begin:: Aside -->
  <div
    class="aside aside-left aside-fixed d-flex flex-column flex-row-auto"
    id="kt_aside"
    ref="kt_aside"
    @mouseover="mouseEnter"
    @mouseleave="mouseLeave"
  >
    <!-- begin:: Aside -->
    <KTBrand></KTBrand>
    <!-- end:: Aside -->

    <!-- begin:: Aside Menu -->
    <div
      class="aside-menu-wrapper flex-column-fluid"
      id="kt_aside_menu_wrapper"
    >
      <div
        ref="kt_aside_menu"
        id="kt_aside_menu"
        class="aside-menu my-4"
        data-menu-vertical="1"
        data-menu-dropdown-timeout="500"
        v-bind:class="asideMenuClass"
      >
        <!-- example static menu here -->
        <perfect-scrollbar
          class="aside-menu scroll"
          style="max-height: 90vh; position: relative"
        >
          <KTMenu></KTMenu>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
  <!-- end:: Aside -->
</template>

<script>
import { mapGetters } from "vuex";
import KTBrand from "@/view/layout/brand/Brand.vue";

import KTLayoutAside from "@/assets/js/layout/base/aside.js";
import KTLayoutAsideMenu from "@/assets/js/layout/base/aside-menu.js";
import KTMenu from "@/view/layout/aside/Menu.vue";

export default {
  name: "KTAside",
  data() {
    return {
      insideTm: 0,
      outsideTm: 0,
    };
  },
  components: {
    KTBrand,
    KTMenu,
  },
  mounted() {
    this.$nextTick(() => {
      // Init Aside
      KTLayoutAside.init(this.$refs["kt_aside"]);

      // Init Aside Menu
      KTLayoutAsideMenu.init(this.$refs["kt_aside_menu"]);
    });
  },
  methods: {
    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     */
    mouseEnter() {
      if (this.layoutConfig("aside.self.minimize.hoverable")) {
        // check if the left aside menu is fixed
        if (document.body.classList.contains("aside-fixed")) {
          if (this.outsideTm) {
            clearTimeout(this.outsideTm);
            this.outsideTm = null;
          }

          // if the left aside menu is minimized
          if (document.body.classList.contains("aside-minimize")) {
            document.body.classList.add("aside-minimize-hover");

            // show the left aside menu
            document.body.classList.remove("aside-minimize");
          }
        }
      }
    },

    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     */
    mouseLeave() {
      if (this.layoutConfig("aside.self.minimize.hoverable")) {
        if (document.body.classList.contains("aside-fixed")) {
          if (this.insideTm) {
            clearTimeout(this.insideTm);
            this.insideTm = null;
          }

          if (document.querySelector(".aside-menu .scroll")) {
            document.querySelector(".aside-menu .scroll").scrollTop = 0;
          }

          // if the left aside menu is expand
          if (document.body.classList.contains("aside-minimize-hover")) {
            // hide back the left aside menu
            document.body.classList.remove("aside-minimize-hover");
            document.body.classList.add("aside-minimize");
          }
        }
      }
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "getClasses"]),

    /**
     * Get extra classes for menu based on the options
     */
    asideMenuClass() {
      const classes = this.getClasses("aside_menu");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },
  },
};
</script>

<style>
/* TODO: fix broken theme dark somehow */
.aside {
  background-color: #1e1e2d;
}

.aside .aside-menu.ps > .ps__rail-x {
  background-color: transparent;
}

.aside .aside-menu.ps > .ps__rail-x:focus,
.aside .aside-menu.ps > .ps__rail-x:hover {
  opacity: 1;
  background-color: transparent;
}

.aside .aside-menu.ps > .ps__rail-x:focus > .ps__thumb-x,
.aside .aside-menu.ps > .ps__rail-x:hover > .ps__thumb-x {
  opacity: 1;
}

.aside .aside-menu.ps > .ps__rail-x > .ps__thumb-x,
.aside .aside-menu.ps > .ps__rail-x > .ps__thumb-x:focus,
.aside .aside-menu.ps > .ps__rail-x > .ps__thumb-x:hover {
  background-color: #637099;
  opacity: 1;
}

.aside .aside-menu.ps > .ps__rail-y {
  background-color: transparent;
}

.aside .aside-menu.ps > .ps__rail-y:focus,
.aside .aside-menu.ps > .ps__rail-y:hover {
  background-color: transparent;
  opacity: 1;
}

.aside .aside-menu.ps > .ps__rail-y:focus > .ps__thumb-y,
.aside .aside-menu.ps > .ps__rail-y:hover > .ps__thumb-y {
  opacity: 1;
}

.aside .aside-menu.ps > .ps__rail-y > .ps__thumb-y,
.aside .aside-menu.ps > .ps__rail-y > .ps__thumb-y:focus,
.aside .aside-menu.ps > .ps__rail-y > .ps__thumb-y:hover {
  background: #637099;
  opacity: 1;
}

.aside-menu {
  background-color: #1e1e2d;
}

.aside-menu .menu-nav > .menu-item > .menu-heading .menu-text,
.aside-menu .menu-nav > .menu-item > .menu-link .menu-text {
  color: #a2a3b7;
}

.aside-menu .menu-nav > .menu-item > .menu-heading .menu-icon,
.aside-menu .menu-nav > .menu-item > .menu-link .menu-icon {
  color: #494b74;
}

.aside-menu
  .menu-nav
  > .menu-item
  > .menu-heading
  .menu-icon.svg-icon
  svg
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item
  > .menu-link
  .menu-icon.svg-icon
  svg
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
  fill: #494b74;
}

.aside-menu
  .menu-nav
  > .menu-item
  > .menu-heading
  .menu-icon.svg-icon
  svg:hover
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item
  > .menu-link
  .menu-icon.svg-icon
  svg:hover
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
}

.aside-menu
  .menu-nav
  > .menu-item
  > .menu-heading
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item
  > .menu-heading
  .menu-bullet.menu-bullet-line
  > span,
.aside-menu
  .menu-nav
  > .menu-item
  > .menu-link
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item
  > .menu-link
  .menu-bullet.menu-bullet-line
  > span {
  background-color: #5c5e81;
}

.aside-menu .menu-nav > .menu-item > .menu-heading .menu-arrow,
.aside-menu .menu-nav > .menu-item > .menu-link .menu-arrow {
  color: #5c5e81;
}

.aside-menu .menu-nav > .menu-item.menu-item-open {
  -webkit-transition: background-color 0.3s;
  transition: background-color 0.3s;
}

.aside-menu .menu-nav > .menu-item.menu-item-open > .menu-heading,
.aside-menu .menu-nav > .menu-item.menu-item-open > .menu-link {
  background-color: #1b1b28;
}

.aside-menu .menu-nav > .menu-item.menu-item-open > .menu-heading .menu-text,
.aside-menu .menu-nav > .menu-item.menu-item-open > .menu-link .menu-text {
  color: #fff;
}

.aside-menu .menu-nav > .menu-item.menu-item-open > .menu-heading .menu-icon,
.aside-menu .menu-nav > .menu-item.menu-item-open > .menu-link .menu-icon {
  color: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item.menu-item-open
  > .menu-heading
  .menu-icon.svg-icon
  svg
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item.menu-item-open
  > .menu-link
  .menu-icon.svg-icon
  svg
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
  fill: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item.menu-item-open
  > .menu-heading
  .menu-icon.svg-icon
  svg:hover
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item.menu-item-open
  > .menu-link
  .menu-icon.svg-icon
  svg:hover
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
}

.aside-menu
  .menu-nav
  > .menu-item.menu-item-open
  > .menu-heading
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item.menu-item-open
  > .menu-heading
  .menu-bullet.menu-bullet-line
  > span,
.aside-menu
  .menu-nav
  > .menu-item.menu-item-open
  > .menu-link
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item.menu-item-open
  > .menu-link
  .menu-bullet.menu-bullet-line
  > span {
  background-color: #3699ff;
}

.aside-menu .menu-nav > .menu-item.menu-item-open > .menu-heading .menu-arrow,
.aside-menu .menu-nav > .menu-item.menu-item-open > .menu-link .menu-arrow {
  color: #fff;
}

.aside-menu .menu-nav > .menu-item.menu-item-here {
  -webkit-transition: background-color 0.3s;
  transition: background-color 0.3s;
}

.aside-menu .menu-nav > .menu-item.menu-item-here > .menu-heading,
.aside-menu .menu-nav > .menu-item.menu-item-here > .menu-link {
  background-color: #1b1b28;
}

.aside-menu .menu-nav > .menu-item.menu-item-here > .menu-heading .menu-text,
.aside-menu .menu-nav > .menu-item.menu-item-here > .menu-link .menu-text {
  color: #fff;
}

.aside-menu .menu-nav > .menu-item.menu-item-here > .menu-heading .menu-icon,
.aside-menu .menu-nav > .menu-item.menu-item-here > .menu-link .menu-icon {
  color: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item.menu-item-here
  > .menu-heading
  .menu-icon.svg-icon
  svg
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item.menu-item-here
  > .menu-link
  .menu-icon.svg-icon
  svg
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
  fill: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item.menu-item-here
  > .menu-heading
  .menu-icon.svg-icon
  svg:hover
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item.menu-item-here
  > .menu-link
  .menu-icon.svg-icon
  svg:hover
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
}

.aside-menu
  .menu-nav
  > .menu-item.menu-item-here
  > .menu-heading
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item.menu-item-here
  > .menu-heading
  .menu-bullet.menu-bullet-line
  > span,
.aside-menu
  .menu-nav
  > .menu-item.menu-item-here
  > .menu-link
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item.menu-item-here
  > .menu-link
  .menu-bullet.menu-bullet-line
  > span {
  background-color: #3699ff;
}

.aside-menu .menu-nav > .menu-item.menu-item-here > .menu-heading .menu-arrow,
.aside-menu .menu-nav > .menu-item.menu-item-here > .menu-link .menu-arrow {
  color: #fff;
}

.aside-menu .menu-nav > .menu-item.menu-item-active {
  -webkit-transition: background-color 0.3s;
  transition: background-color 0.3s;
}

.aside-menu .menu-nav > .menu-item.menu-item-active > .menu-heading,
.aside-menu .menu-nav > .menu-item.menu-item-active > .menu-link {
  background-color: #1b1b28;
}

.aside-menu .menu-nav > .menu-item.menu-item-active > .menu-heading .menu-text,
.aside-menu .menu-nav > .menu-item.menu-item-active > .menu-link .menu-text {
  color: #fff;
}

.aside-menu .menu-nav > .menu-item.menu-item-active > .menu-heading .menu-icon,
.aside-menu .menu-nav > .menu-item.menu-item-active > .menu-link .menu-icon {
  color: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item.menu-item-active
  > .menu-heading
  .menu-icon.svg-icon
  svg
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item.menu-item-active
  > .menu-link
  .menu-icon.svg-icon
  svg
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
  fill: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item.menu-item-active
  > .menu-heading
  .menu-icon.svg-icon
  svg:hover
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item.menu-item-active
  > .menu-link
  .menu-icon.svg-icon
  svg:hover
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
}

.aside-menu
  .menu-nav
  > .menu-item.menu-item-active
  > .menu-heading
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item.menu-item-active
  > .menu-heading
  .menu-bullet.menu-bullet-line
  > span,
.aside-menu
  .menu-nav
  > .menu-item.menu-item-active
  > .menu-link
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item.menu-item-active
  > .menu-link
  .menu-bullet.menu-bullet-line
  > span {
  background-color: #3699ff;
}

.aside-menu .menu-nav > .menu-item.menu-item-active > .menu-heading .menu-arrow,
.aside-menu .menu-nav > .menu-item.menu-item-active > .menu-link .menu-arrow {
  color: #fff;
}

.aside-menu
  .menu-nav
  > .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover {
  -webkit-transition: background-color 0.3s;
  transition: background-color 0.3s;
}

.aside-menu
  .menu-nav
  > .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-heading,
.aside-menu
  .menu-nav
  > .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-link {
  background-color: #1b1b28;
}

.aside-menu
  .menu-nav
  > .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-heading
  .menu-text,
.aside-menu
  .menu-nav
  > .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-link
  .menu-text {
  color: #fff;
}

.aside-menu
  .menu-nav
  > .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-heading
  .menu-icon,
.aside-menu
  .menu-nav
  > .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-link
  .menu-icon {
  color: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-heading
  .menu-icon.svg-icon
  svg
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-link
  .menu-icon.svg-icon
  svg
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
  fill: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-heading
  .menu-icon.svg-icon
  svg:hover
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-link
  .menu-icon.svg-icon
  svg:hover
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
}

.aside-menu
  .menu-nav
  > .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-heading
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-heading
  .menu-bullet.menu-bullet-line
  > span,
.aside-menu
  .menu-nav
  > .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-link
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-link
  .menu-bullet.menu-bullet-line
  > span {
  background-color: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-heading
  .menu-arrow,
.aside-menu
  .menu-nav
  > .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-link
  .menu-arrow {
  color: #fff;
}

.aside-menu .menu-nav > .menu-item > .menu-arrow {
  color: #1e1e2d;
}

.aside-menu .menu-nav > .menu-section .menu-icon,
.aside-menu .menu-nav > .menu-section .menu-text {
  color: #4c4e6f;
}

.aside-menu .menu-nav > .menu-separator {
  border-bottom: 1px solid #4c4e6f;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item
  > .menu-heading
  .menu-text,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item
  > .menu-link
  .menu-text {
  color: #9899ac;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item
  > .menu-heading
  .menu-icon,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item
  > .menu-link
  .menu-icon {
  color: #494b74;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item
  > .menu-heading
  .menu-icon.svg-icon
  svg
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item
  > .menu-link
  .menu-icon.svg-icon
  svg
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
  fill: #494b74;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item
  > .menu-heading
  .menu-icon.svg-icon
  svg:hover
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item
  > .menu-link
  .menu-icon.svg-icon
  svg:hover
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item
  > .menu-heading
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item
  > .menu-heading
  .menu-bullet.menu-bullet-line
  > span,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item
  > .menu-link
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item
  > .menu-link
  .menu-bullet.menu-bullet-line
  > span {
  background-color: #5c5e81;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item
  > .menu-heading
  .menu-arrow,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item
  > .menu-link
  .menu-arrow {
  color: #5c5e81;
}

.aside-menu .menu-nav > .menu-item .menu-submenu .menu-item.menu-item-open {
  -webkit-transition: background-color 0.3s;
  transition: background-color 0.3s;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-open
  > .menu-heading,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-open
  > .menu-link {
  background-color: #1b1b28;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-open
  > .menu-heading
  .menu-text,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-open
  > .menu-link
  .menu-text {
  color: #fff;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-open
  > .menu-heading
  .menu-icon,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-open
  > .menu-link
  .menu-icon {
  color: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-open
  > .menu-heading
  .menu-icon.svg-icon
  svg
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-open
  > .menu-link
  .menu-icon.svg-icon
  svg
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
  fill: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-open
  > .menu-heading
  .menu-icon.svg-icon
  svg:hover
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-open
  > .menu-link
  .menu-icon.svg-icon
  svg:hover
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-open
  > .menu-heading
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-open
  > .menu-heading
  .menu-bullet.menu-bullet-line
  > span,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-open
  > .menu-link
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-open
  > .menu-link
  .menu-bullet.menu-bullet-line
  > span {
  background-color: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-open
  > .menu-heading
  .menu-arrow,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-open
  > .menu-link
  .menu-arrow {
  color: #fff;
}

.aside-menu .menu-nav > .menu-item .menu-submenu .menu-item.menu-item-here {
  -webkit-transition: background-color 0.3s;
  transition: background-color 0.3s;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-here
  > .menu-heading,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-here
  > .menu-link {
  background-color: #1b1b28;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-here
  > .menu-heading
  .menu-icon,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-here
  > .menu-link
  .menu-icon {
  color: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-here
  > .menu-heading
  .menu-icon.svg-icon
  svg
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-here
  > .menu-link
  .menu-icon.svg-icon
  svg
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
  fill: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-here
  > .menu-heading
  .menu-icon.svg-icon
  svg:hover
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-here
  > .menu-link
  .menu-icon.svg-icon
  svg:hover
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-here
  > .menu-heading
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-here
  > .menu-heading
  .menu-bullet.menu-bullet-line
  > span,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-here
  > .menu-link
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-here
  > .menu-link
  .menu-bullet.menu-bullet-line
  > span {
  background-color: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-here
  > .menu-heading
  .menu-arrow,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-here
  > .menu-link
  .menu-arrow {
  color: #fff;
}

.aside-menu .menu-nav > .menu-item .menu-submenu .menu-item.menu-item-active {
  -webkit-transition: background-color 0.3s;
  transition: background-color 0.3s;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-active
  > .menu-heading,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-active
  > .menu-link {
  background-color: #1b1b28;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-active
  > .menu-heading
  .menu-text,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-active
  > .menu-link
  .menu-text {
  color: #fff;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-active
  > .menu-heading
  .menu-icon,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-active
  > .menu-link
  .menu-icon {
  color: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-active
  > .menu-heading
  .menu-icon.svg-icon
  svg
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-active
  > .menu-link
  .menu-icon.svg-icon
  svg
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
  fill: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-active
  > .menu-heading
  .menu-icon.svg-icon
  svg:hover
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-active
  > .menu-link
  .menu-icon.svg-icon
  svg:hover
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-active
  > .menu-heading
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-active
  > .menu-heading
  .menu-bullet.menu-bullet-line
  > span,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-active
  > .menu-link
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-active
  > .menu-link
  .menu-bullet.menu-bullet-line
  > span {
  background-color: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-active
  > .menu-heading
  .menu-arrow,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item.menu-item-active
  > .menu-link
  .menu-arrow {
  color: #fff;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover {
  -webkit-transition: background-color 0.3s;
  transition: background-color 0.3s;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-heading,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-link {
  background-color: #1b1b28;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-heading
  .menu-text,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-link
  .menu-text {
  color: #fff;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-heading
  .menu-icon,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-link
  .menu-icon {
  color: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-heading
  .menu-icon.svg-icon
  svg
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-link
  .menu-icon.svg-icon
  svg
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
  fill: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-heading
  .menu-icon.svg-icon
  svg:hover
  g
  [fill],
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-link
  .menu-icon.svg-icon
  svg:hover
  g
  [fill] {
  -webkit-transition: fill 0.3s ease;
  transition: fill 0.3s ease;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-heading
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-heading
  .menu-bullet.menu-bullet-line
  > span,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-link
  .menu-bullet.menu-bullet-dot
  > span,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-link
  .menu-bullet.menu-bullet-line
  > span {
  background-color: #3699ff;
}

.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-heading
  .menu-arrow,
.aside-menu
  .menu-nav
  > .menu-item
  .menu-submenu
  .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
  > .menu-link
  .menu-arrow {
  color: #fff;
}

.aside-menu .menu-nav > .menu-item .menu-submenu .menu-section .menu-icon,
.aside-menu .menu-nav > .menu-item .menu-submenu .menu-section .menu-text {
  color: #4c4e6f;
}

.aside-menu .menu-nav > .menu-item .menu-submenu .menu-separator {
  border-bottom: 1px solid #4c4e6f;
}

@media (min-width: 992px) {
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    > .menu-item {
    background: transparent;
  }

  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    > .menu-item
    > .menu-link
    > .menu-icon {
    color: #7c87a6;
  }

  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    > .menu-item.menu-item-hover,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    > .menu-item.menu-item-open {
    background: transparent !important;
  }

  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    > .menu-item.menu-item-hover
    > .menu-link
    > .menu-icon,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    > .menu-item.menu-item-open
    > .menu-link
    > .menu-icon {
    color: #3699ff;
  }

  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    > .menu-item.menu-item-active,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    > .menu-item.menu-item-here {
    background: transparent !important;
  }

  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    > .menu-item.menu-item-active
    > .menu-link
    > .menu-icon,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    > .menu-item.menu-item-here
    > .menu-link
    > .menu-icon {
    color: #3699ff;
  }

  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    > .menu-item:hover {
    background: transparent;
  }

  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    > .menu-item:hover
    > .menu-link
    > .menu-icon {
    color: #3699ff !important;
  }
}

@media (min-width: 992px) {
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu {
    background-color: #fff;
    -webkit-box-shadow: 0 0 50px 0 rgba(82, 63, 105, 0.15);
    box-shadow: 0 0 50px 0 rgba(82, 63, 105, 0.15);
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-heading
    .menu-text,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-link
    .menu-text,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-heading
    .menu-text,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-link
    .menu-text {
    color: #696e92;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-heading
    .menu-icon,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-link
    .menu-icon,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-heading
    .menu-icon,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-link
    .menu-icon {
    color: #a8aabb;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-heading
    .menu-icon.svg-icon
    svg
    g
    [fill],
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-link
    .menu-icon.svg-icon
    svg
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-heading
    .menu-icon.svg-icon
    svg
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-link
    .menu-icon.svg-icon
    svg
    g
    [fill] {
    -webkit-transition: fill 0.3s ease;
    transition: fill 0.3s ease;
    fill: #a8aabb;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-heading
    .menu-icon.svg-icon
    svg:hover
    g
    [fill],
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-link
    .menu-icon.svg-icon
    svg:hover
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-heading
    .menu-icon.svg-icon
    svg:hover
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-link
    .menu-icon.svg-icon
    svg:hover
    g
    [fill] {
    -webkit-transition: fill 0.3s ease;
    transition: fill 0.3s ease;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-heading
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-heading
    .menu-bullet.menu-bullet-line
    > span,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-link
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-link
    .menu-bullet.menu-bullet-line
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-heading
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-heading
    .menu-bullet.menu-bullet-line
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-link
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-link
    .menu-bullet.menu-bullet-line
    > span {
    background-color: #a8aabb;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-heading
    .menu-arrow,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-link
    .menu-arrow,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-heading
    .menu-arrow,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item
    > .menu-link
    .menu-arrow {
    color: #a8aabb;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open {
    -webkit-transition: background-color 0.3s;
    transition: background-color 0.3s;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-heading,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-link,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-heading,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-link {
    background-color: #f3f6f9;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-heading
    .menu-icon,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-heading
    .menu-text,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-link
    .menu-icon,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-link
    .menu-text,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-heading
    .menu-icon,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-heading
    .menu-text,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-link
    .menu-icon,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-link
    .menu-text {
    color: #3699ff;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-heading
    .menu-icon.svg-icon
    svg
    g
    [fill],
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-link
    .menu-icon.svg-icon
    svg
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-heading
    .menu-icon.svg-icon
    svg
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-link
    .menu-icon.svg-icon
    svg
    g
    [fill] {
    -webkit-transition: fill 0.3s ease;
    transition: fill 0.3s ease;
    fill: #3699ff;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-heading
    .menu-icon.svg-icon
    svg:hover
    g
    [fill],
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-link
    .menu-icon.svg-icon
    svg:hover
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-heading
    .menu-icon.svg-icon
    svg:hover
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-link
    .menu-icon.svg-icon
    svg:hover
    g
    [fill] {
    -webkit-transition: fill 0.3s ease;
    transition: fill 0.3s ease;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-heading
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-heading
    .menu-bullet.menu-bullet-line
    > span,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-link
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-link
    .menu-bullet.menu-bullet-line
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-heading
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-heading
    .menu-bullet.menu-bullet-line
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-link
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-link
    .menu-bullet.menu-bullet-line
    > span {
    background-color: #3699ff;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-heading
    .menu-arrow,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-link
    .menu-arrow,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-heading
    .menu-arrow,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-open
    > .menu-link
    .menu-arrow {
    color: #3699ff;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here {
    -webkit-transition: background-color 0.3s;
    transition: background-color 0.3s;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-heading,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-link,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-heading,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-link {
    background-color: #f3f6f9;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-heading
    .menu-icon.svg-icon
    svg:hover
    g
    [fill],
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-heading
    .menu-icon.svg-icon
    svg
    g
    [fill],
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-link
    .menu-icon.svg-icon
    svg:hover
    g
    [fill],
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-link
    .menu-icon.svg-icon
    svg
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-heading
    .menu-icon.svg-icon
    svg:hover
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-heading
    .menu-icon.svg-icon
    svg
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-link
    .menu-icon.svg-icon
    svg:hover
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-link
    .menu-icon.svg-icon
    svg
    g
    [fill] {
    -webkit-transition: fill 0.3s ease;
    transition: fill 0.3s ease;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-heading
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-heading
    .menu-bullet.menu-bullet-line
    > span,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-link
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-link
    .menu-bullet.menu-bullet-line
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-heading
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-heading
    .menu-bullet.menu-bullet-line
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-link
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-here
    > .menu-link
    .menu-bullet.menu-bullet-line
    > span {
    background-color: #3699ff;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active {
    -webkit-transition: background-color 0.3s;
    transition: background-color 0.3s;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-heading,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-link,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-heading,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-link {
    background-color: #f3f6f9;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-heading
    .menu-icon,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-heading
    .menu-text,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-link
    .menu-icon,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-link
    .menu-text,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-heading
    .menu-icon,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-heading
    .menu-text,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-link
    .menu-icon,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-link
    .menu-text {
    color: #3699ff;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-heading
    .menu-icon.svg-icon
    svg
    g
    [fill],
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-link
    .menu-icon.svg-icon
    svg
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-heading
    .menu-icon.svg-icon
    svg
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-link
    .menu-icon.svg-icon
    svg
    g
    [fill] {
    -webkit-transition: fill 0.3s ease;
    transition: fill 0.3s ease;
    fill: #3699ff;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-heading
    .menu-icon.svg-icon
    svg:hover
    g
    [fill],
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-link
    .menu-icon.svg-icon
    svg:hover
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-heading
    .menu-icon.svg-icon
    svg:hover
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-link
    .menu-icon.svg-icon
    svg:hover
    g
    [fill] {
    -webkit-transition: fill 0.3s ease;
    transition: fill 0.3s ease;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-heading
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-heading
    .menu-bullet.menu-bullet-line
    > span,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-link
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-link
    .menu-bullet.menu-bullet-line
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-heading
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-heading
    .menu-bullet.menu-bullet-line
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-link
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-link
    .menu-bullet.menu-bullet-line
    > span {
    background-color: #3699ff;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-heading
    .menu-arrow,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-link
    .menu-arrow,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-heading
    .menu-arrow,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item.menu-item-active
    > .menu-link
    .menu-arrow {
    color: #3699ff;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover {
    -webkit-transition: background-color 0.3s;
    transition: background-color 0.3s;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-heading,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-link,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-heading,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-link {
    background-color: #f3f6f9;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-heading
    .menu-icon,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-heading
    .menu-text,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-link
    .menu-icon,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-link
    .menu-text,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-heading
    .menu-icon,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-heading
    .menu-text,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-link
    .menu-icon,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-link
    .menu-text {
    color: #3699ff;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-heading
    .menu-icon.svg-icon
    svg
    g
    [fill],
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-link
    .menu-icon.svg-icon
    svg
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-heading
    .menu-icon.svg-icon
    svg
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-link
    .menu-icon.svg-icon
    svg
    g
    [fill] {
    -webkit-transition: fill 0.3s ease;
    transition: fill 0.3s ease;
    fill: #3699ff;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-heading
    .menu-icon.svg-icon
    svg:hover
    g
    [fill],
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-link
    .menu-icon.svg-icon
    svg:hover
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-heading
    .menu-icon.svg-icon
    svg:hover
    g
    [fill],
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-link
    .menu-icon.svg-icon
    svg:hover
    g
    [fill] {
    -webkit-transition: fill 0.3s ease;
    transition: fill 0.3s ease;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-heading
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-heading
    .menu-bullet.menu-bullet-line
    > span,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-link
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-link
    .menu-bullet.menu-bullet-line
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-heading
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-heading
    .menu-bullet.menu-bullet-line
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-link
    .menu-bullet.menu-bullet-dot
    > span,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-link
    .menu-bullet.menu-bullet-line
    > span {
    background-color: #3699ff;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-heading
    .menu-arrow,
  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-link
    .menu-arrow,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-heading
    .menu-arrow,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover
    > .menu-link
    .menu-arrow {
    color: #3699ff;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-section
    .menu-text,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-section
    .menu-text {
    color: #a4a7bd;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-section
    .menu-icon,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-section
    .menu-icon {
    color: #aaacc2;
  }

  .aside-menu.aside-menu-dropdown
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-separator,
  .aside-minimize:not(.aside-minimize-hover)
    .aside-menu
    .menu-nav
    .menu-item:not([data-menu-submenu-mode="accordion"]).menu-item-hover
    > .menu-submenu
    .menu-subnav
    .menu-separator {
    border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  }
}
</style>
